export default {"src":"/_next/static/media/vaduz-logo.01cde1e1.svg","height":15,"width":196};